import { useEffect, useRef, useState } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { Box, Container, TextField, Grid, Divider, Typography, Button } from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { ArrowBack, CheckCircleTwoTone } from "@mui/icons-material";
import { DialogAlert } from "../Components/DialogAlert";
import { instance } from "../Components/config";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../Components/AuthContext";
import { UPSE4DetalleProducto } from "../Components/UPSE4DetalleProducto";
import { InstruccionesModal } from "../Components/InstruccionesModal";

function UPSE4Agregar() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const preseleccionInicial = useRef(!!location.state?.idUpse2);
  const [encargado, setEncargado] = useState({ Id: "", Nombre: "" });
  const [anio, setAnio] = useState(0);
  const [tipoPlanificacion, setTipoPlanificacion] = useState("");
  const [mes, setMes] = useState(location.state?.mes || { Id: "", Nombre: "" });
  const [idUpse2, setIdUpse2] = useState(location.state?.idUpse2 || { Id: "", Nombre: "" });
  const [tipoInforme, setTipoInforme] = useState({ Id: "", Nombre: "" });
  const [responsable] = useState({ Id: user.id, Nombre: user.nombre + " " + user.apellido });

  const [categorias, setCategorias] = useState([]);

  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [indexEdicion, setIndexEdicion] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingProductos, setIsLoadingProductos] = useState(false);
  const [openForm, setOpenForm] = useState(false);

  const [listaDetalle, setListaDetalle] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/UPSE2",
    pageState: {}
  });

  useEffect(() => {
    instance.get("/categoriaBeneficiario/listActive")
      .then((res) => {
        setCategorias(res.data);
      })
      .catch(() => { });
  }, []);

  useEffect(() => {
    if (preseleccionInicial.current) {
      preseleccionInicial.current = false;
    } else {
      setMes({ Id: "", Nombre: "" });
      setListaDetalle([]);
    }

    if (idUpse2.Id === "") {
      setAnio(0);
      setTipoPlanificacion("");
      return;
    }

    instance.get(`/upse2/listById/${idUpse2.Id}`)
      .then((res) => {
        setAnio(res.data.anioMeta || 0);
        setTipoPlanificacion(res.data.tipoPlanificacion || "");
      })
      .catch(() => { });
  }, [idUpse2.Id]);

  useEffect(() => {
    if (idUpse2.Id !== "" && mes.Id !== "" && tipoPlanificacion !== "") {
      setIsLoadingProductos(true);
      const endpoint = tipoPlanificacion === "semillas"
        ? `/upse4/cultivaresPlanificados/${idUpse2.Id}/${mes.Id}`
        : `/upse4/productosPlanificados/${idUpse2.Id}/${mes.Id}`;
      instance.get(endpoint)
        .then((res) => {
          setListaDetalle(res.data.map((item) => ({ ...item, revisado: false })));
        })
        .catch((error) => {
          if (error.response?.status === 500) {
            setDialog({
              title: "ERROR",
              text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
            });
          } else {
            setDialog({ title: "ERROR", text: error.response?.data?.message });
          }
          setOpenDialog(true);
        })
        .finally(() => setIsLoadingProductos(false));
    } else {
      setListaDetalle([]);
    }
  }, [idUpse2.Id, mes.Id, tipoPlanificacion]);

  const handleVerDetalle = (producto, index) => {
    setProductoSeleccionado(producto);
    setIndexEdicion(index);
    setOpenForm(true);
  }

  const handleClose = () => {
    setOpenForm(false);
    setIndexEdicion(null);
    setProductoSeleccionado(null);
  }

  const handleSubmit = (payload) => {
    const copia = [...listaDetalle];
    copia[indexEdicion]['detalle'] = payload;
    copia[indexEdicion]['revisado'] = true;
    setListaDetalle(copia);
    setIndexEdicion(null);
    setProductoSeleccionado(null);
  }

  const envioFormulario = (e) => {
    e.preventDefault();

    if (listaDetalle.length === 0) {
      setDialog({
        title: 'Aviso',
        text: 'No hay productos planificados para reportar en el mes seleccionado'
      })
      setOpenDialog(true);
      return;
    }

    const todosRevisados = listaDetalle.every(item => item.revisado === true);
    if (!todosRevisados) {
      setDialog({
        title: 'Falta revisión',
        text: 'Todos los productos deben estar revisados antes de enviar el formulario'
      })
      setOpenDialog(true);
      return;
    }

    setIsLoading(true);
    const payload = {
      idUpse2,
      anioMeta: anio,
      mes,
      encargado,
      tipoInforme,
      tipoPlanificacion,
      listaDetalle,
      idCrea: user.id
    }

    instance.post('/upse4/crear', payload)
      .then(() => {
        setDialog({
          title: 'Aviso',
          text: 'Se ha creado correctamente el formulario',
          redirect: true,
          page: '/UPSE4'
        })
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.mensaje });
        }
      }).finally(() => {
        setIsLoading(false);
        setOpenDialog(true);
      })
  }

  const mostrarBeneficiarios = tipoPlanificacion === "personas";
  const esSemillas = tipoPlanificacion === "semillas";

  return (
    <Container>
      <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>Volver</Button>
        <h2 style={{ textAlign: 'center', flex: 1, margin: 0 }}>Registrar informe mensual metas fisicas UPSE-4</h2>
        <InstruccionesModal clave="UPSE4" />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading}>
          <Container maxWidth="lg" sx={{ marginBottom: 5 }}>
            <Box
              sx={{
                padding: "4px",
                margin: { xs: 0, sm: 1 },
                border: { xs: "0", sm: "1px solid #000" },
              }}
              component="form"
              onSubmit={envioFormulario}
            >
              <Grid
                container
                spacing={3}
                padding={2}
                rowSpacing={1}
                sx={{
                  alignItems: "center",
                }}
              >
                <Grid item xs={12} sm={12}>
                  <h3 style={{ textAlign: 'center', margin: 0 }}>Datos generales</h3>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p>Selecciona UPSE 2</p>
                  <DropDownList
                    required
                    title="Seleccione UPSE2"
                    endpoint={"/upse4/upse2Aprobados?id=" + user.id}
                    selectedItem={idUpse2}
                    setSelectedItem={setIdUpse2}
                    selected={idUpse2.Id || undefined}
                  />
                </Grid>

                <Grid item xs={12} sm={3}>
                  <p>Selecciona el mes a informar</p>
                  <DropDownList
                    required
                    title="Selecciona mes"
                    endpoint={idUpse2.Id !== ""
                      ? `/upse4/mesesDisponibles/${idUpse2.Id}`
                      : undefined}
                    selectedItem={mes}
                    setSelectedItem={setMes}
                    selected={mes.Id || undefined}
                  />
                </Grid>

                <Grid item xs={12} sm={3} marginTop={5}>
                  <TextField
                    required
                    disabled
                    id="anio"
                    label="Año actual"
                    name="anio"
                    type="number"
                    fullWidth
                    value={anio}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={4}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="responsable"
                    label="Responsable"
                    name="responsable"
                    disabled
                    value={responsable.Nombre}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <p>Encargado/a de revisión</p>
                  <DropDownList
                    required
                    title="Seleccione encargado"
                    endpoint={"/users/listActive"}
                    selectedItem={encargado}
                    setSelectedItem={setEncargado}
                  />
                </Grid>

                <Grid item sm={4} />

                <Grid item xs={12} sm={4}>
                  <p>Tipo de informe</p>
                  <DropDownList
                    required
                    title="Seleccione informe"
                    endpoint={"/tipoInforme"}
                    selectedItem={tipoInforme}
                    setSelectedItem={setTipoInforme}
                  />
                </Grid>

                <Grid item sm={4} />

                <Grid item xs={12} sm={12} marginTop={2}>
                  <Divider variant="middle" component="aside" />
                </Grid>

                <Grid item sm={2}></Grid>
                <Grid xs={12} sm={8}>
                  <LoaderBoxCircular isLoading={isLoadingProductos} />
                  {listaDetalle.map((detalle, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 2,
                        border: "1px solid #ccc",
                        borderRadius: 1,
                        padding: 2,
                        marginBottom: 1,
                        marginTop: 2,
                        boxShadow: 1
                      }}
                    >
                      <Box sx={{ flex: '1 1 260px', minWidth: 0 }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {esSemillas
                            ? `${detalle.subproducto} · ${detalle.tipoCultivo} · ${detalle.cultivar}`
                            : `Producto: ${detalle.producto}`}
                        </Typography>
                        <Typography variant="body2">Centro de costo: {detalle.localidad}</Typography>
                        <Typography variant="body2">Meta planificada del mes: {detalle.metaMes}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', gap: 1, flexShrink: 0, flexWrap: 'wrap' }}>
                        <Button variant="outlined"
                          startIcon={<CheckCircleTwoTone />}
                          disabled={!detalle.revisado}
                          color="success"
                          sx={{ whiteSpace: 'nowrap' }}
                        >
                          Informado
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={() => handleVerDetalle(detalle, index)}
                        >
                          Ver
                        </Button>
                      </Box>
                    </Box>
                  ))}
                </Grid>
                <Grid item sm={2}></Grid>

                <Grid item sm={4} />
                <Grid item xs={12} sm={4}>
                  <Button fullWidth variant="contained" type="submit">Enviar</Button>
                </Grid>
                <Grid item sm={4} />
              </Grid>
            </Box>
          </Container>
        </LoaderBoxCircular>
        <UPSE4DetalleProducto
          open={openForm}
          onClose={handleClose}
          onSubmit={handleSubmit}
          producto={productoSeleccionado}
          categorias={categorias}
          mostrarBeneficiarios={mostrarBeneficiarios}
        />
        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
      </Box>
    </Container>
  );
}

export { UPSE4Agregar };
